/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { BackendApiSystemService } from './services/backend-api-system.service';
import { BackendApiAuthService } from './services/backend-api-auth.service';
import { BackendApiMeService } from './services/backend-api-me.service';
import { BackendApiUserDashboardsService } from './services/backend-api-user-dashboards.service';
import { BackendApiProjectsService } from './services/backend-api-projects.service';
import { BackendApiReferencesService } from './services/backend-api-references.service';
import { BackendApiGrafanaService } from './services/backend-api-grafana.service';
import { BackendApiDashboardsService } from './services/backend-api-dashboards.service';
import { BackendApiD9Service } from './services/backend-api-d-9.service';
import { BackendApiD1Service } from './services/backend-api-d-1.service';
import { BackendApiD2Service } from './services/backend-api-d-2.service';
import { BackendApiD4Service } from './services/backend-api-d-4.service';
import { BackendApiD8Service } from './services/backend-api-d-8.service';
import { BackendApiExportService } from './services/backend-api-export.service';
import { BackendApiAdminService } from './services/backend-api-admin.service';
import { BackendApiDebugService } from './services/backend-api-debug.service';
import { BackendApiInternalService } from './services/backend-api-internal.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    BackendApiSystemService,
    BackendApiAuthService,
    BackendApiMeService,
    BackendApiUserDashboardsService,
    BackendApiProjectsService,
    BackendApiReferencesService,
    BackendApiGrafanaService,
    BackendApiDashboardsService,
    BackendApiD9Service,
    BackendApiD1Service,
    BackendApiD2Service,
    BackendApiD4Service,
    BackendApiD8Service,
    BackendApiExportService,
    BackendApiAdminService,
    BackendApiDebugService,
    BackendApiInternalService,
    ApiConfiguration,
  ],
})
export class BackendApiAnalyticsMetadoorInvestModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<BackendApiAnalyticsMetadoorInvestModule> {
    return {
      ngModule: BackendApiAnalyticsMetadoorInvestModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params,
        },
      ],
    };
  }

  constructor(
    @Optional() @SkipSelf() parentModule: BackendApiAnalyticsMetadoorInvestModule,
    @Optional() http: HttpClient,
  ) {
    if (parentModule) {
      throw new Error('BackendApiAnalyticsMetadoorInvestModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575',
      );
    }
  }
}
